import React from 'react';
import { useTranslation } from 'react-i18next';

const LocalizedImage = ({ src, ...props }) => {
  const { i18n } = useTranslation();
  const [imageSrc, setImageSrc] = React.useState(src);

  React.useEffect(() => {
    const { language } = i18n;
    if (language === 'en') {
      setImageSrc(src);
    } else {
      const pathParts = src.split('.');
      const extension = pathParts.pop();
      const newSrc = `${pathParts.join('.')}_${language}.${extension}`;
      setImageSrc(newSrc);
    }
  }, [i18n.language, src]);

  const handleError = () => {
    setImageSrc(src);
  };

  return <img src={imageSrc} onError={handleError} {...props} />;
};

export default LocalizedImage;
